// extracted by mini-css-extract-plugin
export default {"container":"JobOffers-ApplyBlock__container--a60jz","input":"JobOffers-ApplyBlock__input--nSHUQ"};